import * as Sentry from '@sentry/browser';
import { safeJsonStringify } from '@tunein/web-utils';
import formatClientErrorData from 'src/common/utils/formatClientErrorData';

export default function apiClientEffectsErrorCallback(apiBeta) {
  return (error, actionType) => {
    const errorData = formatClientErrorData({
      message: 'client apiClientEffectsMiddleware fetch error',
      context: {
        error,
        actionType,
      },
    });

    // If request was rate-limited, log error to Sentry
    if (error?.response?.status === 429) {
      const { status, statusText, data } = error?.response || {};

      Sentry.captureException('Network request rate-limited', {
        extra: {
          actionType,
          url: error?.request?.url,
          status,
          statusText,
          // 128 characters seems sufficient to get extra failure context, if any. Can be removed later if not useful.
          data: safeJsonStringify(data)?.slice(0, 128),
        },
      });
    }

    apiBeta?.telemetry?.logError(errorData);
  };
}
